import dayjs from "dayjs";
import React from "react";
import { Modal, Form, FloatingLabel } from "react-bootstrap";
const MembershipModal = ({
  show,
  onHide,
  input,
  submitClick,
  handleInput,
  currentMemChange,
}) => {
  return (
    <Modal className="centerModal" size="md" show={show} onHide={onHide} centered>
      <Modal.Header className="position-relative border-0 p-4 mb-1">
        <Modal.Title className="fs-3 text-black fw-semibold">Fill The Details</Modal.Title>
        {/* <span
          className=" userProfile_membershipModal_ok modalClose rounded-circle cursorPointer text-white position-absolute top-50 translate-middle-y d-flex justify-content-center align-items-center"
          onClick={submitClick}
        >
          ok
        </span> */}
      </Modal.Header>
      <Modal.Body className="bg-white py-20 px-4 overflow-y-auto">
        <div className="profilePageModalCheck">
          <Form>
            <FloatingLabel className="mb-4" controlId="floatingInput" label="Enter Institute *">
              <Form.Control
                className="fs-4 userProfile_membershipModal_enterInstitute"
                type="text"
                placeholder="Enter Institute"
                value={input.institute_name}
                name="institute_name"
                onChange={handleInput}
              />
            </FloatingLabel>

            <FloatingLabel className="mb-4" controlId="floatingInput" label="Enter Start Year *">
              <Form.Control
                className="fs-4 userProfile_membershipModal_enterStartYear"
                type="number"
                placeholder="Enter Start Year"
                value={input.start_year}
                name="start_year"
                onChange={handleInput}
              />
            </FloatingLabel>
            <FloatingLabel className="mb-4" controlId="floatingInput" label="Enter End Year *">
              <Form.Control
                className="fs-4 userProfile_membershipModal_enterEndYear"
                type="number"
                placeholder="Enter End Year"
                value={input.end_year}
                name="end_year"
                onChange={handleInput}
              />
            </FloatingLabel>
            <Form.Group className="mb-3" controlId="formBasicCheckbox">
              <Form.Check
                type="checkbox"
                className="userProfile_membershipModal_isCurrentMember"
                label="Current Member"
                value={input.is_current_member}
                name="is_current_member"
                checked={input.is_current_member == 1 ? true : false}
                onChange={(e) => currentMemChange(e)}
              />
            </Form.Group>
            <div className="d-flex flex-wrap centerModalBttns">
              <button
                className="col fs-4 btn btn-danger py-3 px-4 userProfile_emailModal_cancel"
                type="button"
                aria-label="Cancel"
                onClick={onHide}

              >
                Cancel
              </button>
              <button
                className="col fs-4 btn btn-primary py-3 px-4 userProfile_emailModal_submit"
                type="button"
                onClick={submitClick}
                aria-label="Submit"
              >
                Submit
              </button>
            </div>
          </Form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MembershipModal;
